var map = {
	"./10crore/assets/style.css": [
		1342,
		198
	],
	"./24betting/assets/style.css": [
		1343,
		199
	],
	"./betstarexch/assets/style.css": [
		1344,
		184
	],
	"./bitomania/assets/style.css": [
		1345,
		200
	],
	"./blackfair/assets/style.css": [
		1346,
		187
	],
	"./cric247/assets/style.css": [
		1347,
		188
	],
	"./dailyexch/assets/style.css": [
		1348,
		189
	],
	"./indiabet24/assets/style.css": [
		1349,
		201
	],
	"./netflixlike/assets/style.css": [
		1350,
		202
	],
	"./oddswar/assets/style.css": [
		1351,
		203
	],
	"./pacific2021/assets/style.css": [
		1352,
		190
	],
	"./realwin/assets/style.css": [
		1353,
		204
	],
	"./sportswin247/assets/style.css": [
		1354,
		191
	],
	"./testdb/assets/style.css": [
		1355,
		205
	],
	"./whitehorse/assets/style.css": [
		1356,
		192
	],
	"./wst/assets/style.css": [
		1357,
		206
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 949;
module.exports = webpackAsyncContext;